const isCmsPath = (path) => {
  if (!path) return null
  const locationRegex = /\/(.*?)\//
  const getPageType = locationRegex.exec(path)
  return getPageType && ['events', 'brands', 'features'].indexOf(getPageType[1]) !== -1
}
const isHelpPath = (path) => {
  if (!path) return null
  const locationRegex = /\/(.*?)\//
  const getPageType = locationRegex.exec(path)
  return getPageType && getPageType[1] === 'help'
}
const isHomepagePath = (path) => (path && path === '/') || false
const isReviewsPath = (path) => (path && path.startsWith('/reviews')) || false
const isReviewsArgosCard = (path) => (path && path.split('reviews/')[1] === 'argos-card') || false
const isMagnoliaApp = (path) => isCmsPath(path) || isHelpPath(path)

const getCleanPath = (path) =>
  path
    .substr(1)
    .split('?')[0]
    .replace(/\//g, '-')

const getRoute = (path) => {
  if (isCmsPath(path)) return 'cms'
  if (isHelpPath(path)) return 'help'
  if (isHomepagePath(path)) return 'homepage'
  if (isReviewsPath(path)) return 'reviews'
  return 'errorpage'
}

export {
  isCmsPath,
  isHomepagePath,
  isReviewsPath,
  isHelpPath,
  isMagnoliaApp,
  isReviewsArgosCard,
  getRoute,
  getCleanPath,
}
